import { FC, useState } from 'react';
import { Portal } from '@mui/material';

import { PaymentMethodType, PaymentSteps } from '@mopla/data-models';

import { PaymentInfoStep } from './PaymentInfoStep';
import { PaymentMethodSelectionStep } from './PaymentMethodSelectionStep';
import { Dialog, Root } from './PaymentSelectSepaOrStripe.styles';

export interface IPaymentSelectSepaOrStripeProps {
	handleOnChange: (value: PaymentSteps) => void;
	handleOnClose: VoidFunction;
}

export const PaymentSelectSepaOrStripe: FC<IPaymentSelectSepaOrStripeProps> = ({
	handleOnChange,
	handleOnClose,
}) => {
	const [step, setStep] = useState<'paymentMethod' | 'info'>('paymentMethod');

	const handleClick = (selectedPaymentMethod: PaymentMethodType) => {
		if (selectedPaymentMethod === 'sepa') {
			setStep('info');
		}
		if (selectedPaymentMethod === 'other') {
			handleOnChange('stripe');
		}
	};

	return (
		<Portal>
			<Root textAlign="left">
				<Dialog>
					{step === 'paymentMethod' && (
						<PaymentMethodSelectionStep
							handleClick={handleClick}
							handleOnClose={handleOnClose}
						/>
					)}
					{step === 'info' && <PaymentInfoStep handleOnClose={handleOnClose} />}
				</Dialog>
			</Root>
		</Portal>
	);
};
